import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react'
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer } from "recharts";


export default function Section2() {

    const [isActivetab, setActivetab] = useState('div1')

    const handleActivetoggle = (tab) => {
        setActivetab(tab)
    }

    const [hideTicks, setHideTicks] = useState(window.innerWidth < 1050);

    useEffect(() => {
        const handleResize = () => {
            setHideTicks(window.innerWidth < 1050);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const data = [
        { subject: "ACTN3 , ACE , PPARGC1A Gene", value: 90 },
        { subject: "Explosive sprints", value: 75 },
        { subject: "Prolonged endurance", value: 80 },
        { subject: "Cardiovascular Efficiency", value: 85 },
        { subject: "Fast-twitch muscle", value: 70 },
        { subject: "Cognitive flexibility", value: 65 },
        { subject: "Rapid decision-making", value: 50 },
    ]

    const data2 = [
        { subject: "Neuro Muscular Coordination Genes – BDNF and COMT", value: 90 },
        { subject: "Precise motor control", value: 75 },
        { subject: "Rapid reaction times", value: 80 },
        { subject: "Upper body strength", value: 85 },
        { subject: "Joint stability", value: 70 },
    ]
    const data3 = [
        { subject: "Muscle strength", value: 90 },
        { subject: "Connective Tissue resilience", value: 75 },
        { subject: "Ligament laxity", value: 80 },
        { subject: "Collagen gene", value: 85 },
    ]
    const data4 = [
        { subject: "ACTN3 Gene", value: 90 },
        { subject: "Explosive power", value: 75 },
        { subject: "Speed", value: 80 },
        { subject: "Muscle integrity", value: 85 },
        { subject: "Tendon integrity", value: 70 },
    ]


    return (
        <div className='min-h-screen py-10 grid content-center'>
            <div className='w-[90%] mx-auto'>
                <h1 className='mt-5 text-center text-3xl lg:text-4xl 2xl:text-5xl font-semibold '>What Makes You Tick on the Pitch?</h1>
                <p className='capitalize text-center mt-3'>Pick your position and watch your player traits come to life. Midfield magic? Goalkeeper instincts? Let’s map your game!</p>
                <div className='flex flex-col lg:flex-row items-center gap-10 mt-3'>
                    <div className='w-[100%] lg:w-[50%] text-lg space-y-5'>
                        <div className={`rounded-full border py-3 px-5 2xl:py-5 2xl:px-10 duration-500 flex items-center justify-between cursor-pointer
                            ${isActivetab === 'div1' ? 'font-bold w-[100%] bg-black border-[#AB11ED]' : 'w-[80%] brightness-50'}`}
                            onClick={() => handleActivetoggle('div1')}>
                            <p className='flex items-center gap-5'><span>01</span> Midfielder</p>
                            <FontAwesomeIcon icon={faArrowRight} />
                        </div>
                        <div className={`rounded-full border py-3 px-5 2xl:py-5 2xl:px-10 duration-500 flex items-center justify-between cursor-pointer
                            ${isActivetab === 'div2' ? 'font-bold w-[100%] bg-black border-[#AB11ED]' : 'w-[80%] brightness-50'}`}
                            onClick={() => handleActivetoggle('div2')}>
                            <p className='flex items-center gap-5'><span>02</span> Goalkeepers</p>
                            <FontAwesomeIcon icon={faArrowRight} />
                        </div>
                        <div className={`rounded-full border py-3 px-5 2xl:py-5 2xl:px-10 duration-500 flex items-center justify-between cursor-pointer
                            ${isActivetab === 'div3' ? 'font-bold w-[100%] bg-black border-[#AB11ED]' : 'w-[80%] brightness-50'}`}
                            onClick={() => handleActivetoggle('div3')}>
                            <p className='flex items-center gap-5'><span>03</span> Defenders</p>
                            <FontAwesomeIcon icon={faArrowRight} />
                        </div>
                        <div className={`rounded-full border py-3 px-5 2xl:py-5 2xl:px-10 duration-500 flex items-center justify-between cursor-pointer
                            ${isActivetab === 'div4' ? 'font-bold w-[100%] bg-black border-[#AB11ED]' : 'w-[80%] brightness-50'}`}
                            onClick={() => handleActivetoggle('div4')}>
                            <p className='flex items-center gap-5'><span>04</span> Forwards</p>
                            <FontAwesomeIcon icon={faArrowRight} />
                        </div>
                    </div>
                    <div className='w-[100%] lg:w-[50%]'>
                        {isActivetab === 'div1' && (
                            <div className='flex flex-col items-center'>
                                <ResponsiveContainer width="100%" height={400}>
                                    <RadarChart outerRadius={120} data={data} >
                                        <PolarGrid />
                                        <PolarAngleAxis dataKey="subject" stroke='white' tickSize={15} tick={!hideTicks} />
                                        <PolarRadiusAxis angle={30} domain={[0, 100]} />
                                        <Radar name="Midfielder" dataKey="value" stroke="#A51FFF" fill="#A51FFF" strokeWidth={3} fillOpacity={0.6} />
                                    </RadarChart>
                                </ResponsiveContainer>
                                <div className='block lg:hidden'>
                                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 mt-5 w-full px-4">
                                        {data.map((item, index) => (
                                            <div key={index} className="p-2 text-center text-white rounded-md bg-[#A51FFF]/50">
                                                {item.subject}: <span className="font-bold">{item.value}%</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        )}
                        {isActivetab === 'div2' && (
                            <div className="flex flex-col items-center">
                                <ResponsiveContainer width="100%" height={400}>
                                    <RadarChart outerRadius={120} data={data2}>
                                        <PolarGrid />
                                        <PolarAngleAxis dataKey="subject" stroke="white" tickSize={15} tick={!hideTicks} />
                                        <PolarRadiusAxis angle={30} domain={[0, 100]} />
                                        <Radar name="Goalkeepers" dataKey="value" stroke="#A51FFF" fill="#A51FFF" strokeWidth={3} fillOpacity={0.6} />
                                    </RadarChart>
                                </ResponsiveContainer>
                                <div className='block lg:hidden'>
                                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 mt-5 w-full px-4">
                                        {data2.map((item, index) => (
                                            <div key={index} className="p-2 text-center text-white rounded-md bg-[#A51FFF]/50">
                                                {item.subject}: <span className="font-bold">{item.value}%</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        )}
                        {isActivetab === 'div3' && (
                            <div className="flex flex-col items-center">
                                <ResponsiveContainer width="100%" height={400}>
                                    <RadarChart outerRadius={120} data={data3}>
                                        <PolarGrid />
                                        <PolarAngleAxis dataKey="subject" stroke="white" tickSize={15} tick={!hideTicks} />
                                        <PolarRadiusAxis angle={30} domain={[0, 100]} />
                                        <Radar name="Defenders" dataKey="value" stroke="#A51FFF" fill="#A51FFF" strokeWidth={3} fillOpacity={0.6} />
                                    </RadarChart>
                                </ResponsiveContainer>
                                <div className='block lg:hidden'>
                                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 mt-5 w-full px-4">
                                        {data3.map((item, index) => (
                                            <div key={index} className="p-2 text-center text-white rounded-md bg-[#A51FFF]/50">
                                                {item.subject}: <span className="font-bold">{item.value}%</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        )}
                        {isActivetab === 'div4' && (
                            <div className="flex flex-col items-center">
                                <ResponsiveContainer width="100%" height={400}>
                                    <RadarChart outerRadius={120} data={data4}>
                                        <PolarGrid />
                                        <PolarAngleAxis dataKey="subject" stroke="white" tickSize={15} tick={!hideTicks} />
                                        <PolarRadiusAxis angle={30} domain={[0, 100]} />
                                        <Radar name="Forwards" dataKey="value" stroke="#A51FFF" fill="#A51FFF" strokeWidth={3} fillOpacity={0.6} />
                                    </RadarChart>
                                </ResponsiveContainer>
                                <div className='block lg:hidden'>
                                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 mt-5 w-full px-4">
                                        {data4.map((item, index) => (
                                            <div key={index} className="p-2 text-center text-white rounded-md bg-[#A51FFF]/50">
                                                {item.subject}: <span className="font-bold">{item.value}%</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}
